export default "__VITE_ASSET__ALhTjFS6__"